import classNames from "classnames/bind";
import styles from "./SearchCar.module.scss";
import AllCar from "~/Data/Cars";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { handleHistoryView } from "~/hooks/function";
import React from "react";
const cx = classNames.bind(styles);
function SearchCar({ value, onResult, onBlur }) {
    console.log("SearchCar");
    const handleBlurClick = (car) => {
        onBlur();
        handleHistoryView(car);
    };
    const showCars = AllCar.filter(
        (car) =>
            (value !== "" &&
                car.name
                    .toLowerCase()
                    .trim()
                    .replace(" ", "")
                    .includes(value.trim().replace(" ", "").toLowerCase())) ||
            car.brand
                .trim()
                .replace(" ", "")
                .toLowerCase()
                .includes(value.trim().replace(" ", "").toLowerCase()) ||
            (car.brand + car.name)
                .trim()
                .replace(" ", "")
                .toLowerCase()
                .includes(value.trim().replace(" ", "").toLowerCase())
    );
    useEffect(() => {
        if (value && showCars.length > 1) {
            onResult(showCars.length, "/results");
        } else if (value && showCars.length === 0) {
            onResult(0, "");
        } else if (value && showCars.length === 1) {
            onResult(
                `${showCars[0].brand} ${showCars[0].name}`,
                showCars[0].link,
                showCars[0]
            );
        } else {
            return;
        }
    }, [value, onResult, showCars]);
    // showCars.length > 10 && (showCars.length = 10);
    return (
        <>
            {showCars.length > 0 ? (
                showCars.map((car) => (
                    <Link
                        key={car.ID}
                        className={cx("wrapper")}
                        onClick={() => handleBlurClick(car)}
                        to={car.link}
                    >
                        <div className={cx("car_avatar")}>
                            <img
                                loading="lazy"
                                src={car.avatar}
                                alt={
                                    car.brand +
                                    " " +
                                    car.name +
                                    " " +
                                    car.version
                                }
                            />
                        </div>
                        <div className={cx("car_info")}>
                            <h4 className={cx("car_name")}>{car.name}</h4>
                            <span className={cx("car_description")}>
                                <span>{car.brand}</span>
                                <span>{car.type}</span>
                            </span>
                        </div>
                        <div className={cx("car_price")}>
                            <span className={cx("car_version")}>
                                {`${car.max} Km/h` || car.version}
                            </span>
                            <span className={cx("car_price-vnd")}>
                                {car.price} Tỷ
                            </span>
                        </div>
                    </Link>
                ))
            ) : (
                <div className={cx("no_result")}>Không tìm thấy kết quả</div>
            )}
        </>
    );
}
export default SearchCar;
